import {put,takeEvery} from 'redux-saga/dist/redux-saga-effects-npm-proxy.esm';

import {TYPES as MEDIA_COMMENT_TYPE} from '../../creators/media.comment';

export function* createSuccess(action) {
    try {
        yield put({type: "MEDIA_COMMENTS_ADD", data : action.payload});
        // yield put({type: "ARTICLE_COMMENTS_ADD", data : action.payload});
    } catch (error) {

    }
}

export function* deleteSuccess(action) {
    try {
        yield put({type: "MEDIA_COMMENTS_DELETE", data : action.payload});
        // yield put({type: "USER_TIMELINES_DECREMENT_COMMENT", data : action.payload});
    } catch (error) {

    }
}

export function* updateSuccess(action) {
    try {
        yield put({type: "MEDIA_COMMENTS_UPDATE", data : action.payload});
    } catch (error) {

    }
}

export function* watchMediaComment() {
    yield takeEvery(MEDIA_COMMENT_TYPE.CREATE_SUCCESS, createSuccess);
    yield takeEvery(MEDIA_COMMENT_TYPE.DELETE_SUCCESS, deleteSuccess);
    yield takeEvery(MEDIA_COMMENT_TYPE.UPDATE_SUCCESS, updateSuccess);
}

export default watchMediaComment;

